import { Components, Theme } from "@mui/material";
import { Shades } from "../../../style/Colors";

export const MuiInputBase: Components<Theme>["MuiInputBase"] = {
  styleOverrides: {
    input: {
      "&.Mui-disabled": {
        color: `${Shades.gray60} !important`,
        backgroundColor: Shades.gray10,
        outline: `${Shades.gray30} solid 2px`,
        opacity: 0.9,
      },
    },
  },
};
